<template>
    <div :class="['sqrcl', $style.container]">
        <img
            :class="$style.icon"
            :src="Icon"
            alt="Save Icon"
        />
        <Typography
            size="s"
            type="label"
            :responsive="false"
            :class="$style.label"
        >
            {{ $tr('gameContainer.mobile_login_promo_title') }}
        </Typography>
        <div />
        <OutlineButton
            :class="$style.button_override"
            interfaceTarget="game-top-bar-ignore-button"
            size="s"
            :label="$tr('gameContainer.mobile_login_promo_no_button')"
            @click.stop="emit('close')"
        />
        <Button
            color="lime"
            :class="$style.button_override"
            interfaceTarget="game-top-bar-login-button"
            size="s"
            :label="$tr('gameContainer.mobile_login_promo_save_button')"
            @click.stop="emit('login')"
        />
    </div>
</template>

<script setup lang="ts">
import Button from '@/components/Buttons/Button.vue'
import OutlineButton from '@/components/Buttons/OutlineButton.vue'
import Typography from '@/components/Typography.vue'

import Icon from '../images/save.webp'

const emit = defineEmits<{ close: []; login: [] }>()
</script>

<style module>
.container {
    display: grid;
    align-items: center;
    grid-template-columns: auto auto 1fr auto auto;
    gap: 8px;
    position: absolute;
    height: 40px;
    padding: 0 8px;
    inset: auto 8rem 8rem;
    --sqrcl: var(--radius-24);
    background: rgba(29, 28, 38, 0.56);
    backdrop-filter: blur(4px);
    text-align: center;
}

@media (--tablet-plus) {
    .container {
        inset: auto 4px 4px;
    }
}

.icon {
    height: 24px;
    width: 24px;
}
.button_override {
    height: 24px;
}

.label {
    text-wrap: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

@media (--desktop-small-plus) {
    .container {
        display: none;
    }
}
</style>
